var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 309,
    viewBox: "0 0 391 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.322 175.758L280.943 277.016L143.652 348.211L0 246.953V71.1951L137.322 0V175.758Z",
    fill: "#00EC7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.709 259.242L172.057 158.016L309.379 86.7893L453 188.047V363.805L315.678 435L315.709 259.242Z",
    fill: "#00EC7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCrop);
export default __webpack_public_path__ + "static/media/logo_crop.d31b17451be4293caf4d7c21e7d23b0c.svg";
export { ForwardRef as ReactComponent };